import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateClinicOfficeDialogComponent } from '../dialogs/create-clinic-office-dialog/create-clinic-office-dialog.component';
import { ReviewCreateClinicOfficeDialogComponent } from '../dialogs/review-create-clinic-office-dialog/review-create-clinic-office-dialog.component';
import { EditClinicOfficeDialogComponent } from '../dialogs/edit-clinic-office-dialog/edit-clinic-office-dialog.component';
import { ReviewEditClinicOfficeDialogComponent } from '../dialogs/review-edit-clinic-office-dialog/review-edit-clinic-office-dialog.component';
import { DeleteClinicOfficeDialogComponent } from '../dialogs/delete-clinic-office-dialog/delete-clinic-office-dialog.component';
import { InfoClinicOfficeDialogComponent } from '../dialogs/info-clinic-office-dialog/info-clinic-office-dialog.component';
import { PublishClinicOfficeDialogComponent } from '../dialogs/publish-clinic-office-dialog/publish-clinic-office-dialog.component';
import { MapDialogComponent } from '../dialogs/map-dialog/map-dialog.component';
import { MapSelectionDialogComponent } from '../dialogs/map-selection-dialog/map-selection-dialog.component';
import { ExportCsvDialogComponent } from '../dialogs/export-csv-dialog/export-csv-dialog.component';
import { HistoryLogDialogComponent } from '../dialogs/history-log-dialog/history-log-dialog.component';
import { GenerateZipLookupTableDialogComponent } from '../dialogs/generate-zip-lookup-table-dialog/generate-zip-lookup-table-dialog.component';
import { DialogContainerComponent } from 'src/common-panel/components/dialog-container/dialog-container.component';
import { ConvertCsvToJsonDialogComponent } from '../dialogs/convert-csv-to-json-dialog/convert-csv-to-json-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogsManagerService
{
  isGoBack: boolean = false

  constructor(public dialog: MatDialog) { }

  showCreateClinicOfficeDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '90vh',
        minWidth: "60em",
        data: CreateClinicOfficeDialogComponent
      });
  }

  showReviewCreateClinicOfficeDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '90vh',
        minWidth: "42em",
        data: ReviewCreateClinicOfficeDialogComponent
      });
  }

  showEditClinicOfficeDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '90vh',
        minWidth: "60em",
        data: EditClinicOfficeDialogComponent
      });
  }

  showReviewEditClinicOfficeDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '90vh',
        minWidth: "42em",
        data: ReviewEditClinicOfficeDialogComponent
      });
  }

  showDeleteClinicOfficeDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '90vh',
        minWidth: "42em",
        data: DeleteClinicOfficeDialogComponent
      });
  }

  showInfoClinicOfficeDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '90vh',
        minWidth: "42em",
        data: InfoClinicOfficeDialogComponent
      });
  }

  showPublishClinicOfficeDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '90vh',
        minWidth: "42em",
        data: PublishClinicOfficeDialogComponent
      });
  }

  showMapDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        maxHeight: '93vh',
        minWidth: "45em",
        data: MapDialogComponent
      });
  }
  
  showHistoryLogDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '93vh',
        minWidth: "45em",
        data: HistoryLogDialogComponent
      });

  }

  showMapSelectionDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '93vh',
        minWidth: "55em",
        data: MapSelectionDialogComponent
      });
  }

  showExportCsvDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '93vh',
        minWidth: "35em",
        data: ExportCsvDialogComponent
      });
  }

  showConvertCsvToJsonDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '93vh',
        minWidth: "35em",
        data: ConvertCsvToJsonDialogComponent
      });
  }

  showGenerateZipLookupTableDialogComponent()
  {
    this.dialog.open(DialogContainerComponent,
      {
        disableClose: true,
        // maxHeight: '93vh',
        minWidth: "35em",
        data: GenerateZipLookupTableDialogComponent
      });
  }
}
